import Vue from "vue";
import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IPartner,
  IPartnerListRequest,
  IPartnerCreateRequest,
  IPartnerUpdateRequest,
  PartnerState,
} from "@/types/partner";

import CustomRequest from "../customRequest";

const actions: ActionTree<PartnerState, RootState> = {
  async salesGet({ commit }, partner_id: number) {
    await CustomRequest.get<IPagination<IPartner>>({
      uri: `/sales/partner/${partner_id}`,
      commit,
      target: "single",
    });
  },

  async salesGetList({ commit }, params: IPartnerListRequest) {
    await CustomRequest.get<IPagination<IPartner>>({
      uri: `/sales/partner`,
      commit,
      target: "pagination",
      params,
    });
  },

  async salesUpdate(
    { commit },
    datas: { partner_id: number; params: IPartnerUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IPagination<IPartner>>({
      uri: `/sales/partner/${datas.partner_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesCreate({ commit }, params: IPartnerCreateRequest) {
    const { error } = await CustomRequest.post<IPagination<IPartner>>({
      uri: `/sales/partner`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesDelete({ commit }, partner_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/partner/${partner_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
